import config from "@Config/index";

const GUMLET_BLOG_DOMAIN = "https://webflow-amber-prod.gumlet.io/";
const CHINA_BLOG_DOMAIN = `${config.CHINA_STATIC_ASSETS_URL}/`;

/**
 * Rewrites blog image URLs for China.
 * Replaces the gumlet domain with the China static assets domain.
 * Returns the original URL unchanged for non-China builds.
 */
const getBlogImageUrl = (url: string): string => {
  if (!url || !config.IS_CHINA_APP) return url;
  if (!url.startsWith(GUMLET_BLOG_DOMAIN)) return url;
  return url.replace(GUMLET_BLOG_DOMAIN, CHINA_BLOG_DOMAIN);
};

export default getBlogImageUrl;
